   import Logo from './Logo';

const LogoSection = () => (
         <Logo />
 );

export default LogoSection;
